import React, { useMemo } from 'react'
import { Flex, Portal, Spinner, Text } from '@chakra-ui/react'
import PropTypes from 'prop-types'

const LoadingSpinner = ({
  icon,
  show,
  size,
  fullPage,
  message,
  speed,
  thickness,
  ...otherProps
}) => {
  const indicator = useMemo(
    () => (
      <Flex
        align="center"
        justify="center"
        direction="column"
        w={fullPage ? '100vw' : '100%'}
        h={fullPage ? '100vh' : '100%'}
        pos={fullPage ? 'fixed' : 'static'}
        top={0}
        left={0}
        backdropBlur={blur ? '1px' : 'none'}
        {...otherProps}
      >
        <Spinner
          speed={`${speed}s`}
          thickness={`${thickness}`}
          w={`${size}rem`}
          h={`${size}rem`}
          emptyColor="gray.200"
          color="brand.400"
        />
        {!!message && (
          <Text
            fontSize="xl"
            mt="2rem"
            color="gray.500"
            textAlign="center"
            fontWeight="500"
          >
            {message}
          </Text>
        )}
      </Flex>
    ),
    [fullPage, message, otherProps, size, speed, thickness]
  )

  if (!show) return null

  return fullPage ? <Portal zIndex={9999}>{indicator}</Portal> : indicator
}

LoadingSpinner.propTypes = {
  show: PropTypes.bool,
  fullPage: PropTypes.bool,
  message: PropTypes.string,
  blur: PropTypes.bool,
  size: PropTypes.string,
  thickness: PropTypes.string
}

LoadingSpinner.defaultProps = {
  show: true,
  fullPage: false,
  blur: false,
  speed: 0.6,
  size: '5',
  message: 'Se incarca...',
  thickness: '10'
}

export default LoadingSpinner
